import React, { Component } from 'react';
import {Checkbox, Pagination} from "react-bootstrap";
import { CSVLink } from "react-csv";
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Form from './components/Form';
import Table from '../../components/StatsTable';
import Graph from './components/Graph';
import API from '../../services/API';
import { PARAMS_NAME, NAN_PARAMS } from "./config";
import {capitalize, handleCheckboxChange, handleFieldChange} from "../../Utils";

class AdkHourly extends Component {
    constructor() {
        super();

        this.state = {
            affidValues: [],
            subidValues: [],
            partnerValues: [],
            params: [],
            paramsObj: {},
            report: [],
            graph: [],
            total: {},
            isLoading: false
        };

        this.handleFieldChange = handleFieldChange.bind(this);
        this.handleCheckboxChange = handleCheckboxChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        this.loadPartners();
        this.loadAffids();

        this.setState({ isLoading: true });

        API.AdkReport.get('hourly', { 'day': new Date().toISOString().split('T')[0] }, 'graph').then(({ graph }) =>
            this.setState({ graph, isLoading: false }));

    }

    handleSubmit(filters, type) {
        this.setState({ isLoading: true });

        if(type === 'subid') return this.loadSubids(filters);

        this.loadReport(filters, type);
    }

    loadAffids() {
        API.AdkFeeds.getIds()
            .then(affids => this.setState({ affidValues: affids }));
    }

    loadPartners() {
        API.AdkPartners.get().then(partners => {
            partners = partners.reduce((obj, { id, name }) => {
                obj[id] = name;

                return obj;
            }, {});

            this.setState({ partnerValues: partners })
        });
    }

    loadReport(filters, type) {
        Promise.all([
            API.AdkReport.get('hourly', filters, type),
            API.AdkReport.get('hourly', filters, 'graph')
        ]).then(([ { params, report, total }, { graph } ]) => {
            const paramsObj = params.reduce((obj, param, index) => {
                obj[param] = index;

                return obj;
            }, {});
            const newState = { params, paramsObj, report, graph, total, isLoading: false };

            this.setState(newState)
        })
    }

    loadSubids(filters) {
        API.AdkReport.get('hourly', filters, 'subid').then(({ subids }) => {
            this.setState({ isLoading: false,  subidValues: subids })
        });
    }

    getGraph() {
        const { graph } = this.state;

        if(!graph.length) return;

        return <Graph data={graph} />;
    }

    render() {
        const { isLoading, affidValues, subidValues, params, paramsObj, report, total } = this.state;

        return (
            <Container loading={isLoading}>
                <Heading title="ADK Hourly V2"/>
                <Form onSubmit={this.handleSubmit} affidValues={affidValues} subidValues={subidValues} partnerValues={this.state.partnerValues}/>

                {this.getGraph()}

                <Table params={params} paramsObj={paramsObj} report={report} total={total} paramNames={PARAMS_NAME} NaNParams={NAN_PARAMS}/>
            </Container>
        );
    }
}

export default AdkHourly;



// WEBPACK FOOTER //
// ./src/scenes/AdkHourlyV2/index.js